'use client';

import { UTCDate } from '@date-fns/utc';
import type { Tournament } from '@/types/tournament';
import { getTournamentPath } from '@/utils/paths';
import { PickemRewardCard } from '../PickemRewardCard';
import { PickemsRewardsHeader } from '../PickemsRewardsHeader';

export const TournamentsRewardsSection = ({
  tournament,
}: {
  tournament: Tournament;
}) => {
  const leaderboardUrl = `${getTournamentPath({
    game: tournament.game,
    slug: tournament.slug,
  })}/leaderboard`;
  return (
    <div className="rounded-xl bg-dark-gray p-8">
      <PickemsRewardsHeader
        countdownDatetime={new UTCDate(tournament.endDateTime)}
        countdownLabel="Tournament leaderboard end in:"
        description="Winners of the contest will have something nice to look forward to! Rewards are courtesy of our partners."
        leaderboardUrl={leaderboardUrl}
        poweredBy={tournament.poweredBy}
        title="Tournament Pickems"
      />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {tournament.rewards.map((reward, index) => (
          <PickemRewardCard index={index} key={reward.label} reward={reward} />
        ))}
      </div>
    </div>
  );
};
